import script from "./AddTutorReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTutorReview.vue?vue&type=script&setup=true&lang=js"

import "./AddTutorReview.vue?vue&type=style&index=0&id=2f69c604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f69c604"]])

export default __exports__